import Popover from '@mui/material/Popover'
import * as React from 'react'
import { Box } from '@mui/material'

const TeamMemberCard = ({ name, role, imgUrl, bio }) => {
    const [anchorEl, setAnchorEl] = React.useState(null)

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handlePopoverClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    return (
        <div
            className="team-member-card mb-3 mb-md-0"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
        >
            <div className="image-with-role d-flex">
                <div className="media-wrapper">
                    <img src={imgUrl} width="100%" height="100%" alt="" />
                </div>
                <h6 className="member-role mt-1 mb-2 py-0 ps-1 ps-md-2 pe-1">
                    {role}
                </h6>
            </div>
            <h3 className="member-name mt-2 pt-0 pt-md-2 mb-0">{name}</h3>

            <Popover
                id="mouse-over-popover"
                sx={{
                    padding: '40px',
                    pointerEvents: 'none',
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal:
                        role === 'President' || role === 'Marketing Manager'
                            ? 'right'
                            : 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal:
                        role === 'President' || role === 'Marketing Manager'
                            ? 'left'
                            : 'right',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Box sx={{ p: 5, width: '500px' }}>
                    <div style={{ marginBottom: '10px' }}>
                        <b>Name :</b> {name}
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                        <b>Position :</b> {role}
                    </div>
                    <div>
                        <b>Bio :</b> {bio}
                    </div>
                </Box>
            </Popover>
        </div>
    )
}

export default TeamMemberCard
